export enum ProductClassificationEnum {
  color = 'color',
  height = 'height',
  depth = 'depth',
  width = 'width',
  netVolume = 'netvolume',
  grossWeight = 'grossweight',
  isSterile = 'issterile',
  netWight = 'netweight',
  containsPvc = 'containspvc',
  grossVolume = 'grossvolume',
  containsLatex = 'containslatex',
  brand = 'brand',
  subBrand = 'subbrand',
  typecategory = 'typecategory',
}
